import { useState, useRef, useEffect } from 'react';
import _debounce from 'lodash/debounce';

const DebouncedInputChange = (props) => {
    const {
        onChange,
        value,
        children,
    } = props;
    const [internalValue, setIntervalValue] = useState(value);
    const prevPropsRef = useRef(props);
    const hadTimeToRerender = useRef(true);

    useEffect(() => {
        prevPropsRef.current = props;
    });

    if (value !== prevPropsRef.current.value && value !== internalValue && hadTimeToRerender.current) {
        setIntervalValue(value);
    }

    const debouncedOnChange = useRef(_debounce((debouncedValued) => {
        hadTimeToRerender.current = false;
        onChange(debouncedValued);
        setTimeout(() => {
            hadTimeToRerender.current = true;
        }, 1000);
    }, 400));

    const handleOnChange = (valueParam) => {
        setIntervalValue(valueParam);
        debouncedOnChange.current(valueParam);
    };

    return children(internalValue, handleOnChange);
};

export default DebouncedInputChange;
